"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const TableHead_1 = __importDefault(require("@mui/material/TableHead"));
const TableRow_1 = __importDefault(require("@mui/material/TableRow"));
const utils_1 = require("@mui/utils");
const style_1 = require("./style");
function SortableTableHeader({ order, orderBy, onRequestSort, headCells, testId = "" }) {
    const createSortHandler = (property) => () => {
        onRequestSort(property);
    };
    return (react_1.default.createElement(TableHead_1.default, null,
        react_1.default.createElement(TableRow_1.default, null, headCells.map((headCell) => {
            return (react_1.default.createElement(style_1.THeadCell, { key: headCell.id, align: headCell?.numeric ? "right" : "left", padding: headCell.disablePadding ? "none" : "normal", sortDirection: orderBy === headCell.id ? order : false },
                react_1.default.createElement(style_1.StyledTableSortLabel, { "data-testid": testId, active: orderBy === headCell.id, direction: orderBy === headCell.id ? order : "asc", onClick: createSortHandler(headCell.id) },
                    headCell.label,
                    orderBy === headCell.id ? (react_1.default.createElement(Box_1.default, { component: "span", sx: utils_1.visuallyHidden }, order === "desc"
                        ? "sorted descending"
                        : "sorted ascending")) : null)));
        }))));
}
exports.default = SortableTableHeader;
